import React from "react";

const LinkedSection = ({ id, children, navigateToSection }) => {
  console.log("navigateToSection in LinkedSection:", navigateToSection); // Verify navigateToSection is passed

  return (
    <div className="linked-section" id={id}>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child; // Skip non-React elements
        return React.cloneElement(child, { navigateToSection }); // Pass navigateToSection explicitly
      })}
    </div>
  );
};

export default LinkedSection;
